import React, { useContext, useEffect, useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import RoomContext from "../../context/RoomContext";
import { FormattedMessage } from "react-intl";
import { createStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import WhiteBoard, {
  getWhiteBoardData,
  loadWhiteBoardData,
} from "fabric-whiteboard";
import { removeWhiteBoardHasChanges } from "../../actions/whiteBoardActions";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: "#fff",
      padding: theme.spacing(2),
      height: "100%",
    },
    mobileVisibleArea: {
      border: "1px dashed #E0E2E6",
      width: 280,
      height: 460,
      position: "absolute",
      marginLeft: 1,
      marginTop: 1,
      textAlign: "center",
    },
  })
);

const WhiteBoardContainer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isXS = useMediaQuery(theme.breakpoints.down("xs"));
  const { roomClient } = useContext(RoomContext);
  const [mode, setMode] = useState("select");
  const [brushColor, setBrushColor] = useState("#2196f3");
  const [brushThickness, setBrushThickness] = useState(2);
  const [loading, setLoading] = useState(true);
  const [width, setWidth] = useState(500);
  const [height, setHeigt] = useState(500);
  const [refWhiteBoard, setRefWhiteBoard] = useState(null);

  const data = useSelector((state) => state.whiteboard.data);
  const whiteBoardOpen = useSelector(
    (state) => state.whiteboard.whiteBoardOpen
  );

  const getCanvasSize = () => {
    const canvasContainerElement = document.getElementById(
      "whiteboard-container"
    );
    if (canvasContainerElement) {
      return {
        width: canvasContainerElement.clientWidth - 40,
        height: canvasContainerElement.clientHeight - 40,
      };
    }
    return null;
  };

  useEffect(() => {
    loadWhiteBoardData(refWhiteBoard, data);
  }, [data, refWhiteBoard]);

  useEffect(() => {
    if (whiteBoardOpen) {
      dispatch(removeWhiteBoardHasChanges());
      const sizes = getCanvasSize();
      if (sizes) {
        setWidth(sizes.width);
        setHeigt(sizes.height);
        setLoading(false);
      }
    } else {
      setLoading(true);
    }
  }, [whiteBoardOpen, dispatch]);

  const sendData = () => {
    const jsonData = getWhiteBoardData(refWhiteBoard);
    let event = {
      data: jsonData, //JSON.stringify(jsonData)
    };
    roomClient.sendWhiteBoardEvent(event);
  };
  return (
    <div className={classes.root} id="whiteboard-container">
      {!isXS && (
        <div className={classes.mobileVisibleArea}>
          <FormattedMessage
            id="whiteboard.mobileVisibleArea"
            defaultMessage="Mobile visible area"
          />
        </div>
      )}

      {!loading && (
        <WhiteBoard
          ref={(ref) => {
            setRefWhiteBoard(ref);
            loadWhiteBoardData(ref, data);
          }}
          width={width + "px"}
          height={height + "px"}
          showToolbar={isXS ? false : true}
          enableToolbar={isXS ? false : true}
          showBoard={true}
          mode={mode}
          onModeClick={(mode) => setMode(mode)}
          brushColor={brushColor}
          brushColors={[
            "#f44336",
            "#e91e63",
            "#9c27b0",
            "#673ab7",
            "#3f51b5",
            "#2196f3",
          ]}
          brushThickness={brushThickness}
          onBrushColorChange={(color) => setBrushColor(color.hex)}
          onBrushThicknessChange={(thickness) => setBrushThickness(thickness)}
          onObjectAdded={sendData}
          onObjectsModified={sendData}
          onObjectsRemoved={sendData}
          onSelectionCleared={sendData}
        />
      )}
    </div>
  );
};

export default WhiteBoardContainer;
